import {
  Autocomplete,
  Box,
  FormHelperText,
  TextField,
  Typography,
} from "@mui/material";
import { Control, Controller } from "react-hook-form";

import ChatFormLabel from "src/reusable/components/ChatFormLabel";
import { Toolkit } from "src/views/assistant/types";

interface ToolkitSelectProps {
  name: string;
  control: Control<any>;
  options: Toolkit[];
  placeholder?: string;
  label?: string;
  helperText?: string;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string;
}

const ToolkitSelect = ({
  name,
  control,
  options,
  placeholder = "Select toolkits",
  label,
  helperText,
  disabled = false,
  error = false,
  errorMessage,
}: ToolkitSelectProps) => {
  return (
    <Box>
      {label && <ChatFormLabel label={label} />}
      {helperText && (
        <FormHelperText sx={{ mb: 1 }}>{helperText}</FormHelperText>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <Autocomplete
            multiple
            id={`toolkit-select-${name}`}
            options={options}
            value={value || []}
            onChange={(_, newValue) => onChange(newValue)}
            getOptionLabel={(option: Toolkit) => option.name}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            renderOption={(props, option) => (
              <li {...props} key={option.name}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    textAlign: "left",
                  }}
                >
                  <Box>
                    <Typography variant="body1" noWrap>
                      {option.name}
                    </Typography>
                  </Box>

                  <Box>
                    <Typography variant="body2" color="text.secondary" noWrap>
                      {option.description || "No description available"}
                    </Typography>
                  </Box>
                </Box>
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder={placeholder}
                size="small"
                error={error}
                helperText={error ? errorMessage : ""}
              />
            )}
            disabled={disabled}
          />
        )}
      />
    </Box>
  );
};

export default ToolkitSelect;
